<template>
    <div class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
                <button type="button" data-dismiss="modal" class="modal-close" @click="closeModal()" aria-label="Cancel">
                    <i class="fas fa-lg fa-times"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-4 col-xl-3"
                            :class="{'border-right' :!$breakpoint.smAndDown, 'px-0 mb-5' :$breakpoint.smAndDown}"
                        >
                            <h3 class="mb-2 px-3 w-100">{{ user._id ? `${user.firstName} ${user.lastName}` : "New User" }}</h3>
                            <!-- ACCOUNT INFORMATION -->
                            <account-information 
                                :account="account"
                                :isModal="true" 
                                class="px-2 py-3" 
                            />
                        </div>

                        <div class="col-md-8 col-xl-9">
                            <user-information :key="user._id" :user="Object.assign({}, user)" :account="account"
                                :class="{'pl-3' : !$breakpoint.smAndDown}" :isModal="true"
                                @updateUser="changesSaved()" @closeUserInformation="closeModal()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import AccountInformation from "@/components/Account/AccountInformation.vue";
import UserInformation from "@/components/Account/UserInformation.vue";

export default {
    mixins: [breakpoint],
    components: {
        AccountInformation,
        UserInformation
    },
    props: {
        user: Object,
        account: Object
    },
    methods: {
        closeModal: function(){
            $(this.$el).modal('hide');
            this.$emit("closeUserModal");
        },
        changesSaved: function(){
            $(this.$el).modal('hide');
            this.$emit("changesSaved");
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>